// -- global var --
var glideContacts = [];

ready(function(){

	// -------------
	// -- GALLERY --
	// -------------
	const glideContact = document.querySelectorAll('.glide.type--contact');
	var glideContactControls = {
		type: 'slider',
		perView: 3,
	  perSwipe: '|',
		gap: 15,
		bound: true,
		animationDuration: 800,
		breakpoints: {
			1023: {
				perView: 2,
			},
		}
	};
	if (glideContact.length) {
		glideContact.forEach(glide => {
			var slider = new Glide(glide, glideContactControls);
			var perViewValue = slider.selector.dataset.perview*1;
			slider.update({ perView: perViewValue });
			slider.on(['mount.after', 'run', 'resize'], function () {
				var sliderNav = slider.selector.querySelector('.glide__arrows');
				var currentEl = slider.selector.querySelector('.glide__pages .current');
				var totalEl = slider.selector.querySelector('.glide__pages .total');
			  var slidesLength = slider._c.Sizes.length;
			  var current, total = 1;
			
				// -- calculate value --
			  if (window.innerWidth > 1023) {
			  	current = Math.ceil((slider.index+perViewValue)/perViewValue);
			  	total = Math.ceil(slidesLength/perViewValue);
			  } else {
			  	current = Math.ceil((slider.index+1)/2);
			  	total = Math.ceil(slidesLength/2);
			  }
			  
			  // -- update HTML value --
			  currentEl.innerHTML = current;
			  totalEl.innerHTML = total;

			  // -- show/hide sliderNav if 1/1 --
			  if (current == 1 && total == 1) {
					sliderNav.classList.add('hidden');
			  } else {
					sliderNav.classList.remove('hidden');
			  }

			});
			slider.mount();
			glideContacts.push(slider);
		});
	}

});